import { PLAN_TITLES_BY_SKU } from 'app/constants/freeTrial';
import { commonActionDetail, externalReferrer } from 'app/analytics/selectors';
import {
  SUBSCRIPTION_STARTED,
  SUBSCRIPTION_SELECTED,
  SUBSCRIPTION_REQUESTED,
} from 'app/features/products/actionTypes';
import { ActionDetail, SKU } from 'app/analytics/helpers';

const subscription = {
  [SUBSCRIPTION_SELECTED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Subscription Selected',
    properties: {
      ...ActionDetail({
        ...commonActionDetail(getState()),
        ...payload,
      }),
      ...SKU({
        skuId: payload.sku,
        skuTitle: PLAN_TITLES_BY_SKU[payload.sku],
        skuType: 'alLaCarte',
      }),
      ...externalReferrer(getState()),
    },
  }),
  [SUBSCRIPTION_STARTED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Subscription Started',
    properties: {
      ...SKU({
        skuId: payload.sku,
        skuTitle: PLAN_TITLES_BY_SKU[payload.sku],
        skuType: 'alLaCarte',
      }),
      ...externalReferrer(getState()),
    },
  }),
  [SUBSCRIPTION_REQUESTED]: (getState, { payload }) => ({
    type: 'track',
    name: 'Subscription Requested',
    properties: {
      ...ActionDetail({
        ...commonActionDetail(getState()),
        ...payload,
      }),
      ...SKU({
        skuId: payload.sku,
        skuTitle: PLAN_TITLES_BY_SKU[payload.sku],
        skuType: 'alLaCarte',
      }),
      ...externalReferrer(getState()),
    },
  }),
};

export default subscription;
